import { Component, OnInit, HostListener } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/services/guard/auth.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-prices',
  templateUrl: './prices.component.html',
  styleUrls: ['./prices.component.scss']
})
export class PricesComponent extends BaseComponent implements OnInit {

  constructor(
    translate: TranslateService,
    authService: AuthService,
    deviceDetectorService: DeviceDetectorService,
    route: ActivatedRoute
  ) {
    super(translate, authService, deviceDetectorService, route);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.updatePicture();
  }

  getPicturePercentage(): number {
    // since clientWidth is not working, calculate width based on height ratio
    const p = $('.picture')[0] as any;
    const hRatio = p.clientHeight / p.naturalHeight;
    const pictureWidth = p.naturalWidth * hRatio;

    const containerWidth = $('.container').width();
    const ratio = (pictureWidth / containerWidth) - 0.1;
    if (ratio > 0.75) {
      return 10 + (ratio * 20);
    }
    return 5;
  }

  @HostListener('window:resize', ['$event'])
  updatePicture() {
    $('.picture').css({ transform: `translate3d(${this.getPicturePercentage()}%, 0px, 0px)` });
  }

}
